module.exports = __webpack_public_path__ + "img/faculty-giselle.edfa08ea.png";